import React from 'react'
import Switch from "react-switch";

/*eslint-disable*/

interface Props {
  colorsData: any,
  showTowersBtn: boolean,
  handleShowTowersBtn: any
  propertiesData: any
}

interface State {
  wordToShow: string
}

class HotspotsBtnMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
     this.state = {
      wordToShow : ""
     }
  }

  componentDidMount(): void {
    var attributesHirarchical: any = []
    this.props.propertiesData.attributes.map((attribute: any) => {
      if(attribute.type === 'Hierarchical'){
        attributesHirarchical.push(attribute)
      }
      

      return 0
    })
    attributesHirarchical.map((attributes: any, index: number) => {
      if(attributes.type === 'Hierarchical' && attributes.padre !== null && attributesHirarchical.length > 1){
        this.setState({
          wordToShow: attributes.name.toLowerCase()
        })
      }
      else{
        this.setState({
          wordToShow: attributes.name.toLowerCase()
        })
      }
    })
  }

  render(): React.ReactNode {
      return(
        <div className='show-towers-btn-mobile'>
          <div className='show-towers-name-mobile'>Mostrar {this.state.wordToShow}</div>
          <Switch
            checked={this.props.showTowersBtn}
            onChange={() => {this.props.handleShowTowersBtn()}}
            onColor="#E0E0E0"
            offColor="#E0E0E0"
            checkedIcon={false}
            uncheckedIcon={false}
            onHandleColor={this.props.colorsData.main_buttons}
            offHandleColor='#E0E0E0'
            height={12}
            width={25}
            handleDiameter={16}
            className="switch-towers-btns-mobile"
          />
        </div>
      )
  }
}

export default HotspotsBtnMobile